import { render } from "./OrderItemDisplay.vue?vue&type=template&id=845aedca"
import script from "./OrderItemDisplay.vue?vue&type=script&lang=js"
export * from "./OrderItemDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__